import React, { useRef, useState } from 'react';

const Tooltip = ({ children, content, side = 'bottom' }) => {
  const triggerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  if (!content) return children;

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      let top = 0;
      let left = rect.left + rect.width / 2;

      // Calculate position based on side
      switch (side) {
        case 'top':
          top = rect.top - 8;
          break;
        case 'bottom':
          top = rect.bottom + 8;
          break;
        case 'left':
          top = rect.top + rect.height / 2;
          left = rect.left - 8;
          break;
        case 'right':
          top = rect.top + rect.height / 2;
          left = rect.right + 8;
          break;
        default:
          top = rect.bottom + 8;
      }

      setPosition({ top, left });
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    setIsVisible(false);
  };

  return (
    <>
      <span
        ref={triggerRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        className="inline-flex items-center justify-center"
      >
        {children}
      </span>

      {isVisible && (
        <div
          className="fixed z-[9999] px-2 py-1 bg-zinc-900 text-white text-[10px] font-bold rounded shadow-lg whitespace-nowrap pointer-events-none"
          style={{
            top: `${position.top}px`,
            left: `${position.left}px`,
            transform: side === 'top' || side === 'bottom'
              ? 'translateX(-50%) translateY(' + (side === 'top' ? '-100%' : '0') + ')'
              : 'translateY(-50%) translateX(' + (side === 'left' ? '-100%' : '0') + ')',
          }}
        >
          {content}
          {/* Arrow */}
          <div
            className={`absolute w-2 h-2 bg-zinc-900 rotate-45 ${
              side === 'top' ? 'bottom-[-3px] left-1/2 -translate-x-1/2' : ''
            }${side === 'bottom' ? 'top-[-3px] left-1/2 -translate-x-1/2' : ''}${
              side === 'left' ? 'right-[-3px] top-1/2 -translate-y-1/2' : ''
            }${side === 'right' ? 'left-[-3px] top-1/2 -translate-y-1/2' : ''}`}
          />
        </div>
      )}
    </>
  );
};

export default Tooltip;
